import { assignIn } from 'lodash-es'

export class BillingKey {
  constructor(billingKey = {}) {
    assignIn(this, assignIn(this, billingKey))
  }

  hasAutoPayment() {
    return this.autoPaymentTypeCode !== undefined && this.autoPaymentTypeCode !== 'NONE'
  }
}